import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useLocation } from "react-router-dom";
import { Route, Routes } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import { fetchRooms } from "./BackendHelpers";
import { isUserAuthenticated } from "./../components/misc/login/auth-handler";

import Home from "../components/Home";
import Search from "../components/search/Search";
import Room from "../components/room/Room";
import QrScanner from "./search/QrScanner";
import Onboarding from "./onboarding/Onboarding";

function AnimatedRoutes() {
  const location = useLocation();

  const [firstVisitCookies, setFistVisitCookie] = useCookies(["firstVisit"]);
  const [roomsForFiltering, setRoomsForFiltering] = useState();
  const [allRooms, setAllRooms] = useState();
  const [allRoomIDs, setAllRoomIDs] = useState();
  const [allRoomBuildings, setAllRoomBuildings] = useState();
  const [loggedIn, setLoggedIn] = useState(false);

  /* React hook that will be executed on creation and every time the dependencies update. */
  useEffect(() => {
    const checkAuthUser = async () => {
      const isAuthed = await isUserAuthenticated();
      setLoggedIn(isAuthed);
    };

    const getData = async () => {
      /*
       * Room Data
       */
      /* Fetch all rooms from the backend. */
      const roomsFromServer = await fetchRooms();
      setAllRooms(roomsFromServer);

      /* Map the rooms to a filterable format for the SelectPicker */
      // Assignment of a 'label' and a 'value'  is necessary by the way the SelectPicker component handles its data
      // 'label' is the displayed text
      // 'value' is the assigned value; in our case the UUID for each room --> needed to be passed as identifier for the later called details page
      // 'building' is the tag, for which the list will be filtered in the SelectPicker component
      const roomsMapped = roomsFromServer.map((item) => ({
        label: item.hoersaal,
        value: item.raumcode,
        building: item.bauwerk,
      }));
      setRoomsForFiltering(roomsMapped);

      /* Map the IDs individually to perform further tasks within the individual components. */
      const roomIDs = roomsFromServer.map((item) => item.raumcode);
      setAllRoomIDs(roomIDs);

      /* Map and filter all buildings from the dataset to perform further tasks within the individual components. */
      const roomBuildings = roomsFromServer.map((item) => item.bauwerk);
      const roomBuildingsFiltered = roomBuildings.filter((c, index) => {
        return roomBuildings.indexOf(c) === index;
      });
      setAllRoomBuildings(roomBuildingsFiltered);
    };

    checkAuthUser();
    getData();
  }, [loggedIn]);

  return (
    <AnimatePresence>
      <Routes location={location} key={location.pathname}>
        {/* Home */}
        <Route path="/" element={<Home visitCookie={firstVisitCookies} />} />

        {/* Onboarding */}
        <Route
          path="/onboarding"
          element={
            <Onboarding
              serverData={{
                roomsForFiltering,
                allRooms,
                allRoomIDs,
                allRoomBuildings,
              }}
              setVisitCookie={setFistVisitCookie}
            />
          }
        />

        {/* Search */}
        <Route
          path="/search"
          element={
            <Search
              serverData={{
                roomsForFiltering,
                allRooms,
                allRoomIDs,
                allRoomBuildings,
              }}
            />
          }
        />

        {/* QR Search */}
        <Route
          path="/search/qr"
          element={
            <QrScanner
              serverData={{
                roomsForFiltering,
                allRooms,
                allRoomIDs,
                allRoomBuildings,
              }}
            />
          }
        />

        {/* Room */}
        <Route
          path="/room/:roomID"
          element={
            <Room
              serverData={{
                roomsForFiltering,
                allRooms,
                allRoomIDs,
                allRoomBuildings,
              }}
              loggedIn={loggedIn}
              setLoggedIn={setLoggedIn}
            />
          }
        />
      </Routes>
    </AnimatePresence>
  );
}

export default AnimatedRoutes;
